export const FIELD_NAMES = {
  country: 'country',
  payout_method_type: '__bank',
  first_name: 'first_name',
  last_name: 'last_name',
  company_name: 'company_name',
  identification_value: 'identification_value',
  identification_type: 'identification_type',
  payment_method_type: 'payment_method_type',
  iban: 'iban',
  swift: 'bic_swift',
  card_expiration_month: 'card_expiration_month',
  card_expiration_year: 'card_expiration_year',
  card_expiration: 'card_expiration',
  card_number: 'card_number',
  recurrence_type: 'recurrence_type',
  date_of_birth: 'date_of_birth'
};

export const ERROR_MESSAGES = {
  [FIELD_NAMES.country]: 'required_country_error',
  [FIELD_NAMES.payout_method_type]: 'required_payout_method_type',
  [FIELD_NAMES.first_name]: 'required_first_name',
  [FIELD_NAMES.last_name]: 'required_last_name',
  [FIELD_NAMES.company_name]: 'required_company_name',
  [FIELD_NAMES.payment_method_type]: 'required_payment_method_type',
  [FIELD_NAMES.card_number]: 'invalid_card_number',
  required_field: 'required_field_error',
  invalid_field: 'invalid_field'
};

export const ENTITY_TYPES = {
  individual: 'individual',
  company: 'company'
};

export const STATUSES = {
  new: 'NEW',
  done: 'DON',
  after_payment: 'AFT'
};

export const SPLIT_FROM_REQUIRED_FIELDS = [
  FIELD_NAMES.first_name,
  FIELD_NAMES.last_name,
  FIELD_NAMES.company_name
];

export const FORCE_STRICT_REGEXES = { [FIELD_NAMES.iban]: true };

export const TOOLTIPS = {
  [FIELD_NAMES.iban]: [
    { text: 'AT', description: 'iban_tooltip_country_code', width: 44 },
    { text: '61', description: 'iban_tooltip_check_digits', width: 36 },
    { text: '15043', description: 'iban_tooltip_bank_identifier', width: 58 },
    { text: '01234567890', description: 'iban_tooltip_account_number', width: 122 }
  ],
  [FIELD_NAMES.swift]: [
    { text: 'AAAA', description: 'swift_tooltip_institution', width: 58 },
    { text: 'GB', description: 'swift_tooltip_country', width: 34 },
    { text: '22', description: 'swift_tooltip_city', width: 30 },
    { text: '123', description: 'swift_tooltip_office', width: 38 }
  ]
};
export const SHOW_TOOLTIP = [FIELD_NAMES.iban, FIELD_NAMES.swift];

export const BENEFICIARY_TOKENIZATION_CATEGORIES = { bank: 'bank', card: 'card' };

export enum RECURRENCE_TYPES {
  recurring = 'recurring',
  installment = 'installment',
  unscheduled = 'unscheduled'
}

export enum FIELDS_TYPES {
  date = 'date',
  country = 'country',
  datePicker = 'datePicker'
}
